<template lang="pug">
  .width-100.container.m-top-1
    .field.row.middle.pointer(v-for='field in contentRequiredFieldsList')
      checkbox.m-right-05(circle :checked='isCompleted(field)')
      h2.text-normal.prevent-select(@click='scrollTo(field)') {{ $t(`krea.progressBar.contentMenu.${field}`) }}
</template>

<script>
import { contentRequiredFieldsList, getCompletedField } from '@/constants/kreaEducationalContent'
import Checkbox from '@/components/Inputs/Checkbox'
import { mapState } from 'vuex'
import { routes } from '../../../../router'

export default {
  components: { Checkbox },
  data() {
    return {
      contentRequiredFieldsList
    }
  },
  computed: {
    ...mapState({
      contentCompleteness: state => state.kreaEducationalContent.contentCompleteness
    }),
    isResourceView() {
      return this.$route.name.includes(routes.kreaResource)
    }
  },
  methods: {
    isCompleted(field) {
      return getCompletedField(this.contentCompleteness, field)
    },
    scrollTo(field) {
      if (this.isResourceView) {
        return this.$router.push({
          name: routes.kreaEducationalContent,
          params: {
            id: this.contentCompleteness.id,
            fieldRedirection: field
          }
        })
      }

      this.$emit('clickedField')
      const element = document.getElementById(field)
      const navbarOffset = 90
      const progressBarOffset = 90
      const elementPosition = element.getBoundingClientRect().top
      const offsetPosition = elementPosition + window.pageYOffset - (navbarOffset + progressBarOffset)

      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      })
      element.classList.add('highlight')
      setTimeout(() => {
        element.classList.remove('highlight')
      }, 1500)
    }
  }
}
</script>

<style lang="scss" scoped>
@import 'src/scss/variables/colors.scss';

.container{
  width: 250px;
  background-color: $white;
  border-radius: 5px;
  &>*:not(:last-child){
    border-bottom: 1px solid $light-gray;
  }
}

.field{
  padding: 5px 8px;
}
</style>
